import React from 'react';
import { connect } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const MobileApp = ({ auth }) => {
  const history = useHistory();

  return (
    <div>
      <>
        <div className="content-header">
          <h1>Mobile/Web App Tools</h1>
          <div />
        </div>

        <div className="d-flex justify-content-center align-items-center flex">
          <div className="row justify-content-around align-items-center ">
            <Paper
              onClick={() => { history.push('/admin/mobileApp/trendingTable'); }}
              className="col-6 col-sm-3 d-flex justify-content-center align-items-center rounded m-1 "
              style={{  cursor: 'pointer', height: '15vh' }}
              elevation={5}
            >
              <Typography variant="h5" style={{ fontWeight: 'bold' }}>Trending Tags</Typography>
            </Paper>

            <Paper
              onClick={() => { history.push('/admin/mobileApp/cacheClear/clearCachePage'); }}
              className="col-6 col-sm-3 d-flex justify-content-center align-items-center rounded m-1 "
              style={{  cursor: 'pointer', height: '15vh' }}
              elevation={5}
            >
              <Typography variant="h5" style={{ fontWeight: 'bold' }}>Clear Mobile/Web App Cache</Typography>
            </Paper>

            {auth && auth.user && auth.user.acl && auth.user.acl.includes('mobileAppVersionRead')
            && (
              <Paper
                onClick={() => { history.push('/admin/mobileApp/mobileAppVersion'); }}
                className="col-6 col-sm-3 d-flex justify-content-center align-items-center rounded m-1 "
                style={{  cursor: 'pointer', height: '15vh' }}
                elevation={5}
              >
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>Mobile App Version</Typography>
              </Paper>
            )}
            {auth && auth.user && auth.user.acl && auth.user.acl.includes('giveawayWinnerRead')
            && (
              <Paper
                onClick={() => { history.push('/admin/mobileApp/giveawayWinner'); }}
                className="col-6 col-sm-3 d-flex justify-content-center align-items-center rounded m-1 "
                style={{  cursor: 'pointer', height: '15vh' }}
                elevation={5}
              >
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>Giveaway Winners</Typography>
              </Paper>
            )}

          </div>
        </div>
      </>
    </div>
  );
};

MobileApp.propTypes = {
  auth: PropTypes.shape({ user: PropTypes.shape({ acl: PropTypes.arrayOf(PropTypes.string) }) }).isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)((MobileApp));
